import gsap from "gsap";

//-----------------------------------------------
// Brand Tagline Animation
//-----------------------------------------------

function brand_tagline_animation() {
  // will use gsap here to create stagged fade in line by line

  const sections = document.querySelectorAll(".brand-tagline");

  sections.forEach((section) => {
    const lines = section.querySelectorAll("span.text");

    if (!lines.length) return;

    gsap.set(lines, {
      opacity: 0,
      y: 20,
    });

    gsap.to(lines, {
      opacity: 1,
      y: 0,
      duration: 0.9,
      ease: "power2.out",
      stagger: 0.25,
      scrollTrigger: {
        trigger: section,
        start: "top 75%",
        once: true,
      },
    });
  });
}

brand_tagline_animation();
